type Parse = typeof import("node-html-parser").parse

// Import dinâmico de propósito: o `node-html-parser` só roda no loader do
// PageSEO (servidor), mas o arquivo da section leva o loader junto para o
// bundle do cliente, e um import estático custava ~110 KB minificados em toda
// página. Quem monta JSON-LD chama `loadHtmlParser()` antes.
let parse: Parse | undefined

export async function loadHtmlParser(): Promise<void> {
  parse ??= (await import("node-html-parser")).parse
}

/**
 * Texto simples para schema.org `Product.description` (entidades HTML + tags removidas).
 * Usa [node-html-parser](https://www.npmjs.com/package/node-html-parser), carregado
 * por `loadHtmlParser()`; sem ele cai no fallback por regex.
 */
export function stripHtmlForStructuredData(
  value: string | undefined | null,
): string | undefined {
  if (value == null || value.trim() === '') return undefined
  try {
    if (!parse) throw new Error("node-html-parser não carregado")
    const text = parse(value, { comment: false }).text
    const collapsed = text.replace(/\s+/g, ' ').trim()
    return collapsed || undefined
  } catch {
    return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() || undefined
  }
}

/**
 * Texto para `Product.description` no JSON-LD: tenta candidatos em ordem até obter texto não vazio.
 * Importante para SKUs em `hasVariant`: `undefined` some no JSON e o Google acusa item sem description.
 */
export function resolveDescriptionForSchema(
  ...candidates: Array<string | undefined | null>
): string {
  for (const c of candidates) {
    const out = stripHtmlForStructuredData(c)
    if (out) return out
  }
  return ''
}
